import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { THEME_KEY } from '@/core/storage'
import { applyDocumentTheme, getStoredTheme } from '@/core/theme'

export const useThemeStore = defineStore('theme', () => {
  const mode = ref(getStoredTheme())

  const isDark = computed(() => mode.value === 'dark')

  function setMode(next) {
    const value = next === 'dark' ? 'dark' : 'light'
    mode.value = value
    applyDocumentTheme(value)
    localStorage.setItem(THEME_KEY, value)
  }

  function setLight() {
    setMode('light')
  }

  function setDark() {
    setMode('dark')
  }

  function toggle() {
    setMode(isDark.value ? 'light' : 'dark')
  }

  return { mode, isDark, setMode, setLight, setDark, toggle }
})
